export default {
      id: "agenda_chevron-usage",
      viewBox: "0 0 10 18",
      url: "../dist/images/" + "sprite.svg#agenda_chevron-usage",
      toString: function () {
        return this.url;
      }
    }